export default {
      id: "upload-usage",
      viewBox: "0 0 18 22",
      url: __webpack_public_path__ + "sprite.svg#upload",
      toString: function () {
        return this.url;
      }
    }